var map = {
	"./2026_FIFA_World_Cup.png": 3079,
	"./Bundesliga.png": 6116,
	"./Copa_Del_Rey.png": 5276,
	"./DAZN.png": 1637,
	"./F1.png": 1895,
	"./LaLiga.png": 2264,
	"./Ligue_1.png": 2568,
	"./Logo_Champions_League.png": 8530,
	"./MLS.png": 9352,
	"./Moto_Gp.png": 8381,
	"./Premier_League.png": 8480,
	"./Primeira_Liga.png": 3263,
	"./Serie_A.png": 4402,
	"./Supercopa.png": 6972,
	"./UEFA_Europa_League.png": 1518,
	"./UEFA_Nations.png": 3256,
	"./UFC.png": 3382,
	"./caf.png": 2920,
	"./rsl.png": 961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6252;